// React
import React from 'react';

// Redux
import { connect } from 'react-redux';
import * as actions from 'actions';

// VENDOR UTILS
import { withRouter } from 'react-router-dom';
const moment = require('moment-timezone');

// VENDOR COMPONENTS
import CircularProgress from 'material-ui/CircularProgress';
import { List } from 'material-ui/List';
import SwipeableViews from 'react-swipeable-views';

// COMPONENTS
import { Hero } from 'components/Hero';
import { Content } from 'components/Content/Content';
import { FluidSection } from 'components/FluidSection/FluidSection';
import ServiceCardList from 'components/ServiceCardList/ServiceCardList';
import PText from 'components/Primatives/PText';

// UTILS
import { constants } from '../../constants';

class ConsumerServiceList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            booking: null,
            company: null,
            height: 0,
            gotThread: false,
            provider: null,
            service: null,
            viewIndex: 0,
            width: 0,
        };
    }

    componentWillMount() {
        this.props.getDBProviders();
        this.props.getDBServices();
        this.props.getDBProviderCompanies();
        this.props.getDBServiceCategories();
        this.props.getDBServiceModules();
        // this.props.updateLocation(this.props.location.pathname); // what is this?
    }

    componentDidMount() {
        if (this.props.userId) {
            this.props.getClientData(this.props.userId); // TEST
            // Go to the top of the page on load
            document.getElementById('top').scrollIntoView();

            // this.getProviderCompanyService(this.props);
        }
        if (!this.props.userId && !this.props.loginDialogOpen) {
            // this.props.openLoginDialog();

            setTimeout(() => {
                if (
                    !this.props.userId &&
                    !this.props.userData &&
                    !this.props.loginDialogOpen
                )
                    this.props.openLoginDialog();
            }, 2500);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.userId) {
            // Get the list of services again once new props with more services are received
            if (
                this.props.services &&
                this.props.services.length !== nextProps.services.length
            ) {
                this.props.getDBServices();
            }

            // this.getProviderCompanyService(nextProps);
            // if (this.props.reduxLocation !== nextProps.reduxLocation) {
            //     // console.log('LOCATION HAS CHANGED - UPDATING GLOBAL LOCATION STATE');
            //     this.props.updateLocation(nextProps.location.pathname)
            // }
        }
    }

    handleChangeViewIndex = index => {
        if (index) {
            this.setState({
                viewIndex: index,
            });
        }
    };

    // getModuleDescriptions = () => {
    //     if (this.props.serviceModules) {
    //         return this.props.serviceModules.map(module => {
    //             return module.description;
    //         });
    //         // TODO: NEED TO REDO THE LIST COMPONENT SO IT CAN HANDLE DESCRIPTION AND ID AND ICON NOW JUST PASSING IN DESCRIPTION
    //     }
    // };

    handleServiceSelect = service => {
        this.handleChangeViewIndex(1);

        // SET STATE OF THE CURRENT PROVIDER
        this.setState({
            selectedServiceData: service,
        });

        this.props.setSelectedService(service);

        this.props.loadUpcomingDbBookings({
            userId: this.props.userId,
            serviceId: service._id,
            // clientUid,
            userType: 'client',
        });

        this.props.history.push(`/service/modules/${service._id}`);
        this.props.updateLocation(`/service/modules/${service._id}`);

        // console.log('GETTING CHANNEL @ HANDLE SERVICE SELECT');
        this.props.getMessageThread(this.props.userData, service, threadKey => {
            // console.log('GOT CHANNEL @ HANDLE SERVICE SELECT', threadKey);
        });
    };

    handleBackToServiceList = () => {
        this.setState(
            {
                viewIndex: 0,
            },
            () => {
                // console.log(this.state.viewIndex);
            },
        );
    };

    render() {
        const { provider, service, company } = this.state;

        const {
            userData,
            filteredServices,
            loginDialogOpen,
            userId,
            closeLoginDialog,
        } = this.props;

        const {
            pendingServices,
            inactiveServices,
            activeServices,
            cancelledServices,
        } = filteredServices;

        const isPageDataStillLoading = !userData ||
        !userId ||
        !activeServices ||
        !inactiveServices ||
        !pendingServices;

        if (isPageDataStillLoading) {
            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: 'calc(100vh - 75px)',
                    }}
                >
                    <CircularProgress
                        style={{
                            flex: 1,
                            alignSelf: 'center',
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100vw',
                            height: '100vh',
                            alignItems: 'center',
                        }}
                        size={100}
                    />
                </div>
            );
        }

        // const moduleDescriptionArray = this.getModuleDescriptions();
        const isUserLoggedIn = !!userId;
        // if (this.props.userId && (this.props.emailIsVerified || this.props.emailVerified)) {
        if (loginDialogOpen && isUserLoggedIn) closeLoginDialog();
        // if (!this.props.userId) {
        //     return (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        //         <CircularProgress style={{ flex: 1, width: '100%' }} size={ 100 }/>
        //     </div>);
        // }

        const hasNoActiveServices =
            !activeServices || activeServices.length === 0;
        const hasNoPendingServices =
            !pendingServices || pendingServices.length === 0;
        const hasNoInactiveServices =
            !inactiveServices || inactiveServices.length === 0;
        const hasNoCancelledServices =
            !cancelledServices || cancelledServices.length === 0;
        const hasNoServices =
            hasNoActiveServices &&
            hasNoPendingServices &&
            hasNoInactiveServices &&
            hasNoCancelledServices;

        // console.log(
        //     'noactive/canc/inac/pend/total',
        //     hasNoActiveServices,
        //     hasNoCancelledServices,
        //     hasNoInactiveServices,
        //     hasNoPendingServices,
        //     hasNoServices,
        //     'pending ->',
        //     userData.isPendingActivation,
        // );

        const isUserPendingActivation =
            userData && userData.isPendingActivation;

        if (hasNoServices && !isUserPendingActivation) {
            return (
                <div
                    style={{
                        height: 'calc(100vh - 75px)',
                        justifyContent: 'center',
                        flexDirection: 'row',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    {
                        <PText
                            style={{
                                display: 'flex',
                                alignSelf: 'center',
                                justifyContent: 'center',
                                height: '100%',
                            }}
                        >
                            You currently have no services.
                        </PText>
                    }
                </div>
            );
        }

        if (
            this.props.userId &&
            (this.props.emailIsVerified || this.props.emailVerified)
        ) {
            return (
                <div
                    id="ServiceModulesOuterContainer"
                    style={{
                        alignitems: 'center',
                        display: 'flex',
                        placeContent: 'center',
                    }}
                >
                    <div
                        id="ServiceModulesInnerContainer"
                        style={styles.innerContainerDesktopStyles}
                    >
                        {
                            // this.state.width >= 800 &&
                            <React.Fragment>
                                <div
                                    id="page-section"
                                    style={styles.pageSectionStyles}
                                >
                                    {this.props.dbProviders &&
                                        this.props.userData &&
                                        this.props.filteredServices && (
                                            <div
                                                id="serviceListContainerDesktop"
                                                style={
                                                    styles.serviceListContainerStyles
                                                }
                                            >
                                                <List
                                                    style={{
                                                        width: '100%',
                                                        maxWidth: '100%',
                                                        overflow: 'scroll',
                                                        padding: '8px 20px',
                                                    }}
                                                >
                                                    {activeServices &&
                                                        this.props
                                                            .dbProviders &&
                                                        activeServices.length >
                                                            0 && (
                                                            <React.Fragment>
                                                                <FluidSection
                                                                    style={{
                                                                        marginBottom: -25,
                                                                        paddingBottom: 0,
                                                                    }}
                                                                >
                                                                    <Content
                                                                        subTitleText={
                                                                            'Current Services'
                                                                        }
                                                                    />
                                                                </FluidSection>
                                                                <ServiceCardList
                                                                    services={
                                                                        activeServices
                                                                    }
                                                                    providers={
                                                                        this
                                                                            .props
                                                                            .dbProviders
                                                                    }
                                                                    header="Active Services"
                                                                    serviceState="Active"
                                                                    onServiceSelect={
                                                                        this
                                                                            .handleServiceSelect
                                                                    }
                                                                />
                                                            </React.Fragment>
                                                        )}

                                                    {pendingServices &&
                                                        this.props
                                                            .dbProviders &&
                                                        pendingServices.length >
                                                            0 && (
                                                            <React.Fragment>
                                                                <FluidSection
                                                                    style={{
                                                                        marginBottom: -25,
                                                                        paddingBottom: 0,
                                                                    }}
                                                                >
                                                                    <Content
                                                                        subTitleText={
                                                                            'Upcoming Services'
                                                                        }
                                                                    />
                                                                </FluidSection>
                                                                <ServiceCardList
                                                                    services={
                                                                        pendingServices
                                                                    }
                                                                    providers={
                                                                        this
                                                                            .props
                                                                            .dbProviders
                                                                    }
                                                                    header="Pending Services"
                                                                    serviceState="Pending"
                                                                    onServiceSelect={
                                                                        this
                                                                            .handleServiceSelect
                                                                    }
                                                                />
                                                            </React.Fragment>
                                                        )}

                                                    {cancelledServices &&
                                                        this.props
                                                            .dbProviders &&
                                                        pendingServices.length >
                                                            0 && (
                                                            <React.Fragment>
                                                                <FluidSection
                                                                    style={{
                                                                        marginBottom: -25,
                                                                        paddingBottom: 0,
                                                                    }}
                                                                >
                                                                    <Content
                                                                        subTitleText={
                                                                            'Cancelled Services'
                                                                        }
                                                                    />
                                                                </FluidSection>
                                                                <ServiceCardList
                                                                    services={
                                                                        cancelledServices
                                                                    }
                                                                    providers={
                                                                        this
                                                                            .props
                                                                            .dbProviders
                                                                    }
                                                                    header="Services with Cancellations"
                                                                    serviceState="Cancelled"
                                                                    onServiceSelect={
                                                                        this
                                                                            .handleServiceSelect
                                                                    }
                                                                />
                                                            </React.Fragment>
                                                        )}

                                                    {inactiveServices &&
                                                        this.props
                                                            .dbProviders &&
                                                        inactiveServices.length >
                                                            0 && (
                                                            <React.Fragment>
                                                                <FluidSection
                                                                    style={{
                                                                        marginBottom: -25,
                                                                        paddingBottom: 0,
                                                                    }}
                                                                >
                                                                    <Content
                                                                        subTitleText={
                                                                            'Previous Services'
                                                                        }
                                                                    />
                                                                </FluidSection>
                                                                <ServiceCardList
                                                                    services={
                                                                        inactiveServices
                                                                    }
                                                                    providers={
                                                                        this
                                                                            .props
                                                                            .dbProviders
                                                                    }
                                                                    header="Archived Services"
                                                                    serviceState="Archived"
                                                                    onServiceSelect={
                                                                        this
                                                                            .handleServiceSelect
                                                                    }
                                                                />
                                                            </React.Fragment>
                                                        )}
                                                </List>
                                            </div>
                                        )}
                                </div>
                            </React.Fragment>
                        }
                    </div>
                </div>
            );
        }
        return null;
    }
}

const mapStateToProps = ({
    provider,
    service,
    company,
    auth,
    client,
    booking,
    router,
    chat,
}) => {
    // console.log(`%cROUTER: ${JSON.stringify(router)}`,'color: aqua');
    // console.log('CURRENT COMMUNICATION THREAD', chat.messageThread);

    return {
        loginDialogOpen: auth.loginDialogOpen,
        channel: chat.messageThread,
        reduxLocation: router.location,
        userData: client.clientData,
        userId: auth.authData ? auth.authData.id : null,
        emailIsVerified: auth.verificationStatus,
        emailVerified: auth.authData.emailVerified,
        dbProviders: provider.providers,
        services: service.services,
        serviceCategories: service.categories,
        serviceModules: service.modules,
        companies: company.providerCompanies,
        sbmProvider: booking.provider,
        awaitingBooking: booking.awaitingBooking,
        filteredServices: {
            inactiveServices: service.inactiveServices,
            pendingServices: service.pendingServices,
            activeServices: service.activeServices,
            cancelledServices: service.cancelledServices,
        },
    };
};

// const mapDispatchToProps = () => {

// };

export default withRouter(
    connect(
        mapStateToProps,
        actions,
    )(ConsumerServiceList),
);

const styles = {
    innerContainerDesktopStyles: {
        display: 'flex',
        flexDirection: 'column',
        // flex: 1,
        // height: '100%',
        justifyContent: 'flex-start',
        alignItems: 'stretch',
        padding: 0,
    },
    pageSectionStyles: {
        ...constants.layout.contentWidth,
        height: 'calc(100vh - 73px)' /* REMOVES BOTTOM GAP */,
        display: 'flex',
        flex: 1,
        flexFlow: 'row nowrap',
        alignItems: 'stretch',
        overflow: 'hidden',
    },
    serviceListContainerStyles: {
        display: 'flex',
        flex: '2 0 0%',
        overflow: 'hidden',
        backgroundColor: constants.color.grey5,
    },
};



// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ConsumerServiceList.jsx